<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->


<div class="container">

  <div class="position-relative">
    <p-steps signupMobileStepper [totalSteps]="items.length" class="mobile-stepper" styleClass="mobile-stepper"
             [model]="items | translateMenuItems" [readonly]="true">
    </p-steps>
  </div>

  <router-outlet></router-outlet>
</div>


